import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';

import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { redirectToPaymentSuccessPage, safeUpperCase } from 'common/utilities/utils';
import { DISPOSITION_TYPES, LOCAL_STORAGE_KEYS } from 'common/constants/SharedConstants';
import { updatePostOrderDetails } from 'components/paymentProcessPage/Container/paymentProcessingFn';
import ActiveOrdersItems from 'components/activeOrders/presentation/activeOrdersItems';
import { ACTIVE_ORDERS_CONSTANTS } from 'components/activeOrders/Constants/activeOrderConstants';
import { HeaderFooterHOC } from 'components/HeaderFooterHOC';

const ActiveOrders = props => {
  const { tenantReducer, orderHistoryReducer, profileReducer } = useSelector(data => data);

  const getTitle = useCallback(postActiveOrderDetail => {
    let title = '';
    if (postActiveOrderDetail?.requestedDateTime?.isForNow === false) {
      title = safeUpperCase(translateWithI18Next(ACTIVE_ORDERS_CONSTANTS.SCHEDULED));
    } else if (
      safeUpperCase(postActiveOrderDetail?.service) === DISPOSITION_TYPES.DELIVERY ||
      safeUpperCase(postActiveOrderDetail?.service) === DISPOSITION_TYPES.PICKUP
    ) {
      title = safeUpperCase(postActiveOrderDetail?.service);
    }
    return `${title} ${safeUpperCase(translateWithI18Next(ACTIVE_ORDERS_CONSTANTS.ORDER_HASH))} ${
      postActiveOrderDetail?.posOrderId
    }`;
  }, []);

  const getInfo = useCallback(postActiveOrderDetail => {
    if (postActiveOrderDetail?.requestedDateTime?.isForNow === false) {
      return translateWithI18Next(ACTIVE_ORDERS_CONSTANTS.YOUR_ORDER_IS_SCHEDULED);
    } else if (safeUpperCase(postActiveOrderDetail?.service) === DISPOSITION_TYPES.DELIVERY) {
      return translateWithI18Next(ACTIVE_ORDERS_CONSTANTS.ORDER_GETTING_READY);
    } else if (safeUpperCase(postActiveOrderDetail?.service) === DISPOSITION_TYPES.PICKUP) {
      return translateWithI18Next(ACTIVE_ORDERS_CONSTANTS.ORDER_GETTING_READY);
    }
  }, []);

  const getBtnTxt = useCallback(postActiveOrderDetail => {
    if (postActiveOrderDetail?.requestedDateTime?.isForNow === false) {
      return translateWithI18Next(ACTIVE_ORDERS_CONSTANTS.TRACK_ORDER);
    } else if (safeUpperCase(postActiveOrderDetail?.service) === DISPOSITION_TYPES.DELIVERY) {
      return translateWithI18Next(ACTIVE_ORDERS_CONSTANTS.TRACK_DELIVERY);
    } else if (safeUpperCase(postActiveOrderDetail?.service) === DISPOSITION_TYPES.PICKUP) {
      return translateWithI18Next(ACTIVE_ORDERS_CONSTANTS.PICKUP_DETAILS);
    }
  }, []);

  const getAdditionalInfo = useCallback(postActiveOrderDetail => {
    if (postActiveOrderDetail?.requestedDateTime?.isForNow === false) {
      return translateWithI18Next(ACTIVE_ORDERS_CONSTANTS.SCHEDULED_TIME);
    } else if (safeUpperCase(postActiveOrderDetail?.service) === DISPOSITION_TYPES.PICKUP) {
      return translateWithI18Next(ACTIVE_ORDERS_CONSTANTS.READY_FOR_PICKUP);
    }
  }, []);

  const onTrackOrderBtnClickHandler = useCallback(postActiveOrderDetail => {
    const postOrderDetails = { ...postActiveOrderDetail, customer: profileReducer?.basic };
    const orderDetails = updatePostOrderDetails(tenantReducer?.tenantId, postOrderDetails);
    orderDetails.postOrderDetails = {};
    sessionStorage.setItem(LOCAL_STORAGE_KEYS.ORDER_TRACKING, JSON.stringify(orderDetails));
    redirectToPaymentSuccessPage(props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className='active-orders col-12'>
      <div className='active-orders-title col-12'>
        <img src={IMAGE_PATH.Strips} alt='Red Strip' class='account-icon' />
        <h4 class='currentStatus'>
          {`${translateWithI18Next(ACTIVE_ORDERS_CONSTANTS.CURRENT_ORDERS)} (${
            orderHistoryReducer?.activeOrderHistory?.length
          })`}
        </h4>
      </div>

      <div className='active-orders-list col-12'>
        <ActiveOrdersItems
          orderHistoryReducer={orderHistoryReducer}
          getTitle={getTitle}
          getInfo={getInfo}
          getBtnTxt={getBtnTxt}
          getAdditionalInfo={getAdditionalInfo}
          onTrackOrderBtnClickHandler={onTrackOrderBtnClickHandler}
        ></ActiveOrdersItems>
      </div>
    </div>
  );
};

export default HeaderFooterHOC(ActiveOrders);
